import { useEffect } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/store/authStore';
import { useUsers } from './hooks/useUsers';
import { UserList } from './components/UserList';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

export function Users() {
  const { 
    users, 
    handleAddUser, 
    handleUpdatePhone, 
    handleUpdatePassword,
    handleDeleteUser, 
    showAddDialog, 
    setShowAddDialog 
  } = useUsers();

  const currentUser = useAuthStore((state) => state.user);
  const { fetchUsers, isLoading, error } = useAuthStore();
  const isAdmin = currentUser?.role === 'admin';

  // Fetch users only once when component mounts
  useEffect(() => {
    let mounted = true;

    const loadUsers = async () => {
      if (!mounted) return;
      await fetchUsers();
    };

    loadUsers();

    return () => {
      mounted = false;
    };
  }, []); // Empty dependency array

  if (isLoading && !users?.length) {
    return (
      <div className="flex items-center justify-center h-64">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center p-8 bg-white rounded-lg shadow-sm">
        <p className="text-red-500">{error}</p>
        <Button 
          onClick={fetchUsers}
          className="mt-4"
          variant="outline"
        >
          إعادة المحاولة
        </Button>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <div className="flex-shrink-0 flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">المستخدمين</h2>
        {isAdmin && (
          <Button
            onClick={() => setShowAddDialog(true)}
            className="hover:bg-secondary"
          >
            <Plus className="h-4 w-4 ml-2" />
            إضافة مستخدم
          </Button>
        )}
      </div>

      <div className="flex-1 overflow-y-auto">
        <UserList
          users={users || []}
          isAdmin={isAdmin}
          onAddUser={handleAddUser}
          onUpdatePhone={handleUpdatePhone}
          onUpdatePassword={handleUpdatePassword}
          onDelete={handleDeleteUser}
          showAddDialog={showAddDialog}
          setShowAddDialog={setShowAddDialog}
        />
      </div>
    </div>
  );
}